"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatepickerComponent = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _VerticalStack = _interopRequireDefault(require("../../../VerticalStack/index.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DatepickerComponent = exports.DatepickerComponent = (0, _styledComponents.default)(_VerticalStack.default)`
	${props => {
  const {
    padding,
    daySelectedBg,
    daySelectedColor,
    dayRangeBg,
    dayRangeColor,
    zindexValue = '2',
    hoverDateBgColor,
    hoverDateTextColor,
    onHoverDateRangeBgColor,
    calenderBoxShadow,
    borderRadius,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    onLoadShowCalender = false,
    calenderPadding,
    calenderMargin,
    currentDateBgColor,
    currentDateBorderRadius,
    currentDateBorderWidth = 2,
    currentDateBorderStyle = 'solid',
    currentDateBorderColor,
    currentDateBoxShadow,
    currentDateFontFamily,
    currentDateFontStyle,
    currentDateFontWeight,
    currentDateFontSize,
    currentDateTransformation,
    currentDateDecoration,
    currentDateTextColor,
    selectedDateBorderRadius,
    selectedDateBorderWidth,
    selectedDateBorderStyle,
    selectedDateBorderColor,
    selectedDateBoxShadow,
    selectedDateFontFamily,
    selectedDateFontStyle,
    selectedDateFontWeight,
    selectedDateFontSize,
    selectedDateTransformation,
    selectedDateDecoration,
    dateRangeBorderRadius,
    dateRangeBorderWidth,
    dateRangeBorderStyle,
    dateRangeBorderColor,
    dateRangeBoxShadow,
    dateRangeFontFamily,
    dateRangeFontStyle,
    dateRangeFontWeight,
    dateRangeFontSize,
    dateRangeTransformation,
    dateRangeDecoration,
    datePickerPosition = "",
    calenderAlignment = 'left'
  } = props;
  return (0, _styledComponents.css)`
			position: ${onLoadShowCalender ? 'relative' : 'absolute'};
			z-index: ${zindexValue};
			// min-height: 280px; //commented for dynamic table
			height: auto;
			padding: ${padding};
			${calenderAlignment === 'right' ? (0, _styledComponents.css)`
					right: 0;
					left: auto;
				` : (0, _styledComponents.css)`
					left: ${datePickerPosition};
				`}
			display: inline-flex;
			border-radius: ${borderRadius ?? 4};
			border-width: ${calenderBorderWidth}px;
			border-style: ${calenderBorderStyle};
			border-color: ${calenderBorderColor};
			padding: ${calenderPadding};
			margin: ${calenderMargin};
			${calenderBoxShadow}
			& .datepicker__day-btn:hover {
				background: ${hoverDateBgColor};
			}
			& .datepicker__day-btn:hover > span {
				color: ${hoverDateTextColor};
			}
			& .datepicker__day-btn-today {
				border: ${currentDateBorderWidth}px ${currentDateBorderStyle} ${currentDateBorderColor};
				background-color: ${currentDateBgColor} !important;
				border-radius: ${currentDateBorderRadius ?? 4}px;
				${currentDateBoxShadow};
			}
			& .datepicker__day-btn-today > span {
				color: ${currentDateTextColor};
				font-size: ${currentDateFontSize}px !important;
				font-weight: ${currentDateFontWeight} !important;
				font-family: ${currentDateFontFamily ?? "Nunito Sans"} !important;
				font-style: ${currentDateFontStyle || 'normal'} !important;
				color: ${currentDateTextColor};
				text-transform: ${currentDateTransformation};
				text-decoration: ${currentDateDecoration == 'strike_of' ? 'line-through' : currentDateDecoration == 'underline_overline' ? 'underline overline' : currentDateDecoration};
			}
			& .datepicker__day-selected {
				background: ${daySelectedBg} !important;
				border: ${selectedDateBorderWidth}px ${selectedDateBorderStyle} ${selectedDateBorderColor};
				border-radius: ${selectedDateBorderRadius ?? 4}px;
				${selectedDateBoxShadow};
			}
			& .datepicker__day-selected > span {
				color: ${daySelectedColor};
				font-size: ${selectedDateFontSize}px !important;
				font-weight: ${selectedDateFontWeight} !important;
				font-family: ${selectedDateFontFamily ?? "Nunito Sans"} !important;
				font-style: ${selectedDateFontStyle || 'normal'} !important;
				text-transform: ${selectedDateTransformation};
				text-decoration: ${selectedDateDecoration == 'strike_of' ? 'line-through' : selectedDateDecoration == 'underline_overline' ? 'underline overline' : selectedDateDecoration};
			}
			& .datepicker__day-ranged {
				background: ${dayRangeBg};
				border: ${dateRangeBorderWidth}px ${dateRangeBorderStyle} ${dateRangeBorderColor};
				border-radius: ${dateRangeBorderRadius ?? 4}px;
				${dateRangeBoxShadow};
			}
			& .datepicker__day-ranged > span {
				// background: ${dayRangeBg};
				color: ${dayRangeColor} !important;
				font-size: ${dateRangeFontSize}px !important;
				font-weight: ${dateRangeFontWeight} !important;
				font-family: ${dateRangeFontFamily ?? "Nunito Sans"} !important;
				font-style: ${dateRangeFontStyle || 'normal'} !important;
				text-transform: ${dateRangeTransformation};
				text-decoration: ${dateRangeDecoration == 'strike_of' ? 'line-through' : dateRangeDecoration == 'underline_overline' ? 'underline overline' : dateRangeDecoration};
			}
			& .datepicker__day-ranged:hover > span {
				background: ${onHoverDateRangeBgColor};
			}
		`;
}}
`;